import * as React from "react";
import { cn } from "../../lib/utils";

function Spinner({ className, size = "default", ...props }) {
    const sizes = {
        sm: "h-4 w-4 border-2",
        default: "h-6 w-6 border-2",
        lg: "h-8 w-8 border-[3px]",
        xl: "h-16 w-16 border-[4px]",
    };
    return (
        <span
            role="status"
            aria-label="Načítání..."
            className={cn(
                "inline-block animate-spin rounded-full border-current border-r-transparent",
                sizes[size] || sizes.default,
                className
            )}
            {...props}
        />
    );
}

export { Spinner };
